// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2r1rZ","upload":"Small_upload__2GJ4l","imageWrap":"Small_imageWrap__1IU7K","removeBtn":"Small_removeBtn__4d7GK"};